import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const IssueFilters = ({ filters, onFilterChange, onClearFilters, onSaveFilter }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const severityOptions = [
    { value: 'all', label: 'All Severities' },
    { value: 'critical', label: 'Critical' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
  ];

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'quality', label: 'Quality Issues' },
    { value: 'logistics', label: 'Logistics Delays' },
    { value: 'documentation', label: 'Documentation' },
    { value: 'payment', label: 'Payment Issues' },
    { value: 'compliance', label: 'Compliance' },
    { value: 'operational', label: 'Operational' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'open', label: 'Open' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'pending-approval', label: 'Pending Approval' },
    { value: 'resolved', label: 'Resolved' },
    { value: 'closed', label: 'Closed' }
  ];

  const shipmentOptions = [
    { value: 'all', label: 'All Shipments' },
    { value: 'SHP-2024-001', label: 'SHP-2024-001 - MV Pacific Glory' },
    { value: 'SHP-2024-002', label: 'SHP-2024-002 - MV Ocean Trader' },
    { value: 'SHP-2024-003', label: 'SHP-2024-003 - MV Coal Express' },
    { value: 'SHP-2024-004', label: 'SHP-2024-004 - MV Maritime Star' }
  ];

  const ownerOptions = [
    { value: 'all', label: 'All Owners' },
    { value: 'sarah-chen', label: 'Sarah Chen' },
    { value: 'michael-rodriguez', label: 'Michael Rodriguez' },
    { value: 'priya-sharma', label: 'Priya Sharma' },
    { value: 'james-wilson', label: 'James Wilson' }
  ];

  return (
    <div className="h-full flex flex-col bg-card border-r border-border">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">Filters</h3>
        </div>
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-1 rounded hover:bg-muted transition-colors"
          aria-label={isCollapsed ? 'Expand filters' : 'Collapse filters'}
        >
          <Icon name={isCollapsed ? 'ChevronRight' : 'ChevronLeft'} size={20} />
        </button>
      </div>
      {!isCollapsed && (
        <div className="flex-1 overflow-y-auto custom-scrollbar p-4 space-y-6">
          <div>
            <Select
              label="Severity"
              options={severityOptions}
              value={filters?.severity}
              onChange={(value) => onFilterChange('severity', value)}
            />
          </div>

          <div>
            <Select
              label="Category"
              options={categoryOptions}
              value={filters?.category}
              onChange={(value) => onFilterChange('category', value)}
            />
          </div>

          <div>
            <Select
              label="Status"
              options={statusOptions}
              value={filters?.status}
              onChange={(value) => onFilterChange('status', value)}
            />
          </div>

          <div>
            <Select
              label="Shipment"
              options={shipmentOptions}
              value={filters?.shipment}
              onChange={(value) => onFilterChange('shipment', value)}
              searchable
            />
          </div>

          <div>
            <Select
              label="Owner"
              options={ownerOptions}
              value={filters?.owner}
              onChange={(value) => onFilterChange('owner', value)}
              searchable
            />
          </div>

          <div className="space-y-3">
            <label className="text-sm font-medium text-foreground">Resolution Status</label>
            <Checkbox
              label="Overdue Issues"
              checked={filters?.overdue}
              onChange={(e) => onFilterChange('overdue', e?.target?.checked)}
            />
            <Checkbox
              label="Escalated Issues"
              checked={filters?.escalated}
              onChange={(e) => onFilterChange('escalated', e?.target?.checked)}
            />
            <Checkbox
              label="Has Attachments"
              checked={filters?.hasAttachments}
              onChange={(e) => onFilterChange('hasAttachments', e?.target?.checked)}
            />
          </div>

          <div className="pt-4 border-t border-border space-y-2">
            <Button
              variant="outline"
              fullWidth
              iconName="Save"
              iconPosition="left"
              onClick={onSaveFilter}
            >
              Save Filter
            </Button>
            <Button
              variant="ghost"
              fullWidth
              iconName="X"
              iconPosition="left"
              onClick={onClearFilters}
            >
              Clear All
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default IssueFilters;